export enum DINEOUT_ORDER_STATUSES {
    PLACED = "PLACED",
    COMPLETED = "COMPLETED",
    CONFIRMED = "CONFIRMED",
    PENDING = "PENDING",
    CANCELLED = "CANCELLED",
    FAILED = "FAILED",
}

export const DINEOUT_TERMINAL_ORDER_STATUSES = [
    DINEOUT_ORDER_STATUSES.COMPLETED,
    DINEOUT_ORDER_STATUSES.CONFIRMED,
    DINEOUT_ORDER_STATUSES.PENDING,
    DINEOUT_ORDER_STATUSES.CANCELLED,
    DINEOUT_ORDER_STATUSES.FAILED,
];

export const FREE_RESERVATION_CART_TYPE = "DEAL_TICKET_PURCHASE";

export const FREE_RESERVATION_CART_SOURCE = "direct-payment-cart";
export const FREE_RESERVATION_CART_METADATA_KEYS = "DineoutCartMetaData";

export enum FREE_RESERVATION_PAYMENT_INFO {
    ORDER_CONTEXT_KEY = "ORDER_JOB",
    PAYMENT_TYPE = "PRE_PAYMENT",
}

export const DO_MERCHANT_ID = "SWIGGY";
